import { convertDigitToProperFormat } from 'utils/number';
import i18n from '../../../i18n';

export default {
  addTitle: '+ اضافه کردن توضیح به پاسخ',
  cancel: 'لغو',
  description: 'توضیحات',
  draft: 'پیش‌نویس',
  pleaseFixWarnings: 'لطفاً خطاهای موجود در پرسش‌نامه را برطرف کنید',
  submitMyContainsNotification:
    'ارسال یا به روزرسانی این پاسخ ممکن است با ارسال پیام همراه باشد',
  checkNotifications: 'بررسی مجدد پیام‌ها',
  noMessageWillBeSent: 'پیامی ارسال نمی‌شود',
  submit: 'ارسال',
  update: 'ذخیره',
  dontSendNotification: 'پیام ارسال نشود',
  submitAnonymously: 'ارسال به صورت ناشناس',
  title: 'توضیح پاسخ',
  refill: 'ایا تمایل دارید پاسخ دیگری ارسال کنید',
  periodTimeRequired: 'لطفا بازه مرتبط را مشخص کنید',
  invalidId: 'کدملی وارد شده معتبر نیست',
  fetchDataError: 'خطا در دریافت اطلاعات',
  selectValueToFill: 'لطفا موردی را انتخاب کنید',
  formExpired: 'زمان ارسال به پایان رسیده است و امکان ارسال وجود ندارد',
  noTimeToSend: 'زمان ارسال پاسخ به اتمام رسیده است',
  responseUpdated: 'پاسخ به روز شد',
  responseSend: 'پاسخ با موفقیت ارسال شد',
  responseSendAsDraft: 'پاسخ به صورت پیشنویس ذخیره شد',

  mapQuestionRequired(title: string) {
    return i18n.t('mapQuestionRequired', { ns: 'survey', title });
  },
  questionRequired(questionTitle: string) {
    return i18n.t('questionRequired', { ns: 'survey', questionTitle });
  },
  responseScore(score: number | string, maxScore?: number) {
    const scoreText = convertDigitToProperFormat(score);
    let ret = i18n.t('result', { ns: 'survey', result: scoreText });
    if (maxScore) {
      ret +=
        ' ' +
        i18n.t('fromScore', {
          ns: 'survey',
          score: convertDigitToProperFormat(maxScore),
        });
    }
    return ret;
  },
};
